import { useState } from "react";
import { FAQS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="relative scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="常见问题"
            title="关于吃瓜快手，你想问的都在这里"
            desc="第一次来的瓜友别着急，下面这些高频问题基本能解答你的疑惑；还有疑问欢迎通过底部订阅或页脚邮箱联系我们。"
          />
        </Reveal>

        <div className="mt-12 space-y-3">
          {FAQS.map((faq, idx) => {
            const open = openIdx === idx;
            return (
              <Reveal key={faq.q} delay={(idx % 2) * 60}>
                <div
                  className={`overflow-hidden rounded-2xl border transition ${
                    open ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-100/60"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIdx(open ? -1 : idx)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
                    >
                      <span className="flex items-start gap-3 text-sm md:text-base font-semibold text-foreground-950">
                        <i
                          className={`mt-0.5 text-lg ${open ? "ri-questionnaire-fill text-primary-600" : "ri-questionnaire-line text-secondary-600"}`}
                        />
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${open ? "ri-subtract-fill" : "ri-add-fill"}`}
                      />
                    </button>
                  </h3>
                  <div
                    className={`grid transition-all duration-300 ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-12 text-sm leading-7 text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}